import { render, staticRenderFns } from "./FeedbackCreateDialog.vue?vue&type=template&id=778993dc&"
import script from "./FeedbackCreateDialog.vue?vue&type=script&lang=js&"
export * from "./FeedbackCreateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports